import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import useTranslation from 'next-translate/useTranslation'
import ReactSVG from 'react-svg'
import Link from 'next/link'
import Image from 'next/image'
import { getCurrentLocale } from 'SRC/modules/common/functions'
import { connect } from 'react-redux'
import setLanguage from 'next-translate/setLanguage'
import { getIsAuthorized } from 'SRC/modules/users/Auth/selectors'
import { getUserInfo } from 'SRC/modules/users/Profile/selectors'


const locale = getCurrentLocale()

const UserMenuMobile = ({ isAuthorized, userInfo }) => {
  const { t } = useTranslation('common')
  const lang = locale ? locale.toLowerCase() : 'me'

  useEffect(() => {
    setLanguage(lang)
  }, [])

  return (
    <div className='user-menu-mobile'>
      {isAuthorized ? (
        <div className='user-menu-mobile_item'>
          <Link
            href={{
              pathname: '/profile',
              query: {
                page: 'oglasi',
                status: 'Published'
              }
            }}
            as={'/profil/oglasi'}
          >
            <a>
              <ReactSVG
                src='/icons/ads.svg'
                beforeInjection={svg => {
                  svg.setAttribute('width', '35px')
                  svg.setAttribute('height', '35px')
                  svg.querySelectorAll('path').forEach(path => {
                    path.setAttribute('fill', '#000')
                  })
                }}
              />
              <p>{t('Moji oglasi')}</p>
            </a>
          </Link>
        </div>
      ) : null}

      {!isAuthorized ? (
        <div className='user-menu-mobile_item'>
          <Link href={'/profile'} as={'/profil'}>
            <a>
              <Image src='/icons/user_icon.svg' alt='User' width={35} height={35} />
              <p>
                {t('Prijavi se')}
              </p>
            </a>
          </Link>
        </div>
      ) : (
        <div className='user-menu-mobile_item'>
          <Link href={'/profile'} as={'/profil'}>
            <a>
              <Image src='/icons/user_icon.svg' alt='User' width={35} height={35} />
              <p>
                {userInfo.username || t('Moj Profil')}
              </p>
            </a>
          </Link>
        </div>
      )
      }
    </div>
  )
}

const mapStateToProps = (state) => ({
  isAuthorized: getIsAuthorized(state),
  userInfo: getUserInfo(state),
})

UserMenuMobile.propTypes = {
  isAuthorized: PropTypes.bool.isRequired,
  userInfo: PropTypes.shape({
    id: PropTypes.number.isRequired,
    username: PropTypes.string.isRequired,
  }).isRequired,
}

export default connect(mapStateToProps)(UserMenuMobile)
